
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor-runtime/build/esm/viewerScript.js';
  
  

  
  var importedApp = {};

  import {
    createHttpClient,
  } from '@wix/yoshi-flow-editor-runtime/build/esm/controller/httpClientProp';

  

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor-runtime/build/esm/i18next/init';



  var sentryConfig = {
      DSN: 'https://8a61be5486d247c7a0eef42564383fd4@sentry.wixpress.com/673',
      id: '8a61be5486d247c7a0eef42564383fd4',
      projectName: 'igul-letova-integration',
      teamName: 'wix-developers',
    };

  var experimentsConfig = {"scopes":["test"]};

  var translationsConfig = {"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/agent00/work/dbd519ebd96be495/igul-letova-integration/src/assets/locales/messages_en.json","availableLanguages":["en","uk"]};

  var defaultTranslations = {"app.widget.welcome":"Welcome","app.settings.label":"Configure Widget","app.settings.tabs.main":"Main","app.settings.tabs.design":"Design","app.settings.defaults.greetingsPretext":"to","app.settings.defaults.content.title.first.option":"בקניה הבאה, מעגלים לטובה","app.settings.defaults.content.title.second.option":"כמה אגורות מגשימות חלומות","app.settings.defaults.content.title.third.option":"עיגול קטן, השפעה אדירה","app.settings.defaults.content.content.first.option":"להצטרפות מהירה","app.settings.defaults.content.content.second.option":"לפרטים נוספים","app.settings.defaults.content.content.third.option":"לחצו כאן להצטרפות","app.settings.panel.main.tab.first.paragraph":"Igool Letova is an Israeli non-profit organization that enables customers to round up credit purchases and donate money to charity with each transaction.","app.settings.panel.main.tab.second.paragraph":"Our promotional banner will lead your site visitors to Igool Letova website.","app.settings.panel.main.tab.link":"Visit Igool Letova Website","app.settings.panel.main.tab.button.text":"Choose Layout","app.settings.panel.design.tab.title.section.title":"Title","app.settings.panel.design.tab.title.section.subtitle":"font styles & color","app.settings.panel.design.tab.button.section.title":"Button","app.settings.panel.design.tab.button.section.font.title":"Font settings of Content","app.settings.panel.design.tab.button.section.background.title":"Background Color","app.settings.panel.design.tab.button.section.border.width.title":"Border width (px)","app.settings.panel.design.tab.button.section.border.corner.title":"Corner radius (px)","app.settings.panel.design.tab.background.section.border.corner.title":"Corner radius (px)","app.settings.panel.design.tab.background.section.border.width.title":"Border width (px)","app.settings.panel.design.tab.background.section.background.title":"Background Color","app.settings.panel.design.tab.background.section.title":"Background","app.settings.panel.text.tab.title.title":"Title","app.settings.panel.text.tab.button.title":"Button","app.settings.panel.design.tab.button.section.border.color":"Border color & opacity","app.settings.panel.design.tab.background.section.border.color":"Border color & opacity","app.settings.layout.tab.text.section.header.title":"Text","setting.panel.layout.sticker.option":"Sticker","setting.panel.layout.custom.banner.option":"Custom Banner","app.settings.panel.design.tab.stickers.title":"Choose a design"};

  import biLogger from '/home/builduser/agent00/work/dbd519ebd96be495/igul-letova-integration/node_modules/@wix/bi-logger-editor-flow-template/dist/src/index.js';

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    projectName: "igul-letova-integration",
    biConfig: {"owner":"@wix/bi-logger-editor-flow-template","visitor":"@wix/bi-logger-editor-flow-template","enableUniversalEvents":false},
    appName: "igul-letova",
    appDefinitionId: "50d70424-84c5-4eee-885f-a3e41f82fc66",
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    optionalDeps: {
      initI18n,
      createHttpClient,
    },
    localeDistPath: "assets/locales",
  });

  export const createControllers = createControllersWithDescriptors({
    initI18n,
    createHttpClient,
  }, [{ method: null,
          widgetType: "WIDGET_OUT_OF_IFRAME",
          translationsConfig: translationsConfig,
          experimentsConfig: {"scopes":["test"]},
          biLogger: biLogger,
          biConfig: {"owner":"@wix/bi-logger-editor-flow-template","visitor":"@wix/bi-logger-editor-flow-template","enableUniversalEvents":false},
          controllerFileName: "/home/builduser/agent00/work/dbd519ebd96be495/igul-letova-integration/src/components/igulletovawidget/controller.ts",
          appName: "igul-letova",
          appDefinitionId: "50d70424-84c5-4eee-885f-a3e41f82fc66",
          projectName: "igul-letova-integration",
          componentName: "igulletovawidget",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "03add002-c2c9-4dde-8142-3d0bbe5df619" }], false);
